// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2024project/q1/2024paris_olympics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getHomeMessage = () => {
  return http.get(`${urlPrefix}home-message`);
};


const getRank = () => {
  return http.get(`${urlPrefix}rank`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getOlympicsTime = (page: any) => {
  return http.get(`${urlPrefix}getOlympicsTime`, {
    params: {
      page:page
    },
  });
}

const getGoldTime = (page: any) => {
  return http.get(`${urlPrefix}getGoldTime`, {
    params: {
      page:page
    },
  });
}

export { getBaseInfo, getHomeMessage, getNews, getRank, getOlympicsTime, getGoldTime };
